/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import Layout from '../Layout/Layout'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import { auth } from './firebase';
import axios from 'axios'
import {RecaptchaVerifier, signInWithPhoneNumber} from 'firebase/auth'
import {useAuth} from '../../context/auth';
import {Form} from 'react-bootstrap';
import CountryPhone from '../CountryPhone';
import { useCountry } from '../../context/country';
import { addCartDataAfterLogin } from '../../Helper';
import OtpInput from 'react-otp-input';
import IntlTelInputBox from './IntlTelInputBox';
const App = () => {
  const [CurrCountry] = useCountry();
  const [validated, setValidated] = useState(false);
  const [phone, setPhone] = useState('');
  const [hasFilled, setHasFilled] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpSuccess, setOtpSuccess] = useState({});
  const [country, setCountry]=useState('+91');
  const [selectedCode, setSelectedCode] = useState('+91');
  const [fullPhone, setFullPhone] = useState('');
  const [userType, setUserType] = useState('');
  const [otpTime, setOtpTime] = useState(40);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [lauth, setLauth] = useAuth();
  const [recapGen, setRecapGen] = useState(false);
  const navigate = useNavigate();
  const [errMsg, setErrMsg] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loginData, setLoginData] = useState({});
  const[otpVerify,setOtpVerify]=useState(false);
  const location = useLocation();
  const [otpStatus, setOtpStatus] = useState(false);
  useEffect(() => {
    let isAuth = JSON.parse(localStorage.getItem('auth'));
    if(isAuth && isAuth !== null) {
        navigate("/");
    }
    //eslint-disable-next-line
}, []);

  useEffect(() => {
    if (otpTime > 0) {
      const intervalId = setInterval(() => {
        setOtpTime(otpTime - 1);
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [otpTime]);

  useEffect(() => {
    if(otp.length===6){
      verifyOtp();
    }
  }, [otp]);
  //////////

  const checkResendOTP = async (fullPhone)=>{
    try {
        let {data} = await axios.post(`${process.env.REACT_APP_API_URL}/auth/resendOTP`,{phone:fullPhone});
        if(data?.status){
            return data;
        }else if(!data?.status){
            setErrMsg({cls:'alert alert-danger', msg:"We cannot find an account with this mobile number."});
            return 'guest';
        }
    } catch (error) {
        console.log(error)
    }
  }

  const resendOTP = async (event) => {
    setLoading(true)
    setErrMsg({});
    setOtp('')
    if (isButtonDisabled) {
      return;
    }
    setIsButtonDisabled(true);
    const userVal = await checkResendOTP(fullPhone);
    if(userVal?.status){
      setLoading(false)
      setOtpTime(40);
      setErrMsg({cls:'alert alert-success text-center', msg:userVal.message});
      setIsButtonDisabled(false);
    }else{
      setLoading(false)
      setErrMsg({cls:'alert alert-danger text-center', msg:"OTP not send please try again later!"});
    }
    
  };
  //////

  const generateRecaptcha = () => {
    if(!recapGen){
      window.recaptchaVerifier = new RecaptchaVerifier('recaptcha', {
        'size': 'invisible',
        'callback': (response) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          // ...
        }
      }, auth);
      setLoading(false)
    }
  }

  const checkUserExist = async (fullPhone)=>{
    try {
        let {data} = await axios.post(`${process.env.REACT_APP_API_URL}/auth/sendOTP`,{phone:fullPhone});
        if(data?.status){
            return data;
        }else if(!data?.status){
            setErrMsg({cls:'alert alert-danger', msg:"We cannot find an account with this mobile number."});
            return 'guest';
        }
    } catch (error) {
        console.log(error)
    }
  }

  const checkOTPverify = async (fullPhone, otp)=>{
    try {
        let {data} = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`,{otp:otp,phone:fullPhone});
        if(data?.status){
            return data;
        }else if(!data?.status){
            setErrMsg({cls:'alert alert-danger', msg:"Invalid OTP."});
            //return 'guest';
        }
    } catch (error) {
        console.log(error)
    }
  }

  const handleSend = async (event) => {
    setLoading(true)
    setSubmitting(true)
    setErrMsg({});
      event.preventDefault();
      const form = event.currentTarget;
      //console.log(form)
      if (form.checkValidity() === false) {
        event.stopPropagation();
        setLoading(false)
        setSubmitting(false)
      }
      setValidated(true);
      if(form.checkValidity()===true) {
        setOtpTime(40);
        setFullPhone(fullPhone);
        setErrMsg({cls:'alert alert-warning text-center', msg:"Sending OTP..."});
        const userVal = await checkUserExist(fullPhone);
        if(userVal==='guest'){
          setLoading(false)
          setSubmitting(false)
          return false;
        }
        setUserType(userVal);
        generateRecaptcha();
        setRecapGen(true);
        if(userVal?.status){
          setLoading(false)
          setHasFilled(true);
          setErrMsg({cls:'alert alert-success text-center', msg:userVal.message});
          setOtpStatus(true);
          setSubmitting(false)
        }else{
        setLoading(false)
        setHasFilled(false);
        setErrMsg({cls:'alert alert-danger text-center', msg:"OTP send faild. Please try again!"});
        setSubmitting(false)
        }
        
       
      }
  }
  
  const verifyOtp = async (event) => {
    setLoading(true)
    //console.log(otp)
    if (otp.length === 6) {
      // verify otp
      setOtpVerify(true);
      const checkOTPverifyData = await checkOTPverify(fullPhone, otp);
      if(checkOTPverifyData.status){
        setLoading(false);
        setErrMsg({cls:'alert alert-success text-center', msg:checkOTPverifyData?.message});
        setLoginData({
          ...lauth,
          user:checkOTPverifyData?.results,
          token:checkOTPverifyData?.token
      })
      
        setLauth({
          ...lauth,
          user:checkOTPverifyData?.results,
          token:checkOTPverifyData?.token
      })       
        localStorage.setItem('auth',JSON.stringify({
          ...lauth,
          user:checkOTPverifyData?.results,
          token:checkOTPverifyData?.token
      }))
        addCartDataAfterLogin();
        navigate(-1);
      }else{
        setLoading(false)
        setOtpVerify(false);
        setErrMsg({cls:'alert alert-danger text-center', msg:checkOTPverifyData?.message});  
      }
    }else{
      setLoading(false)
      setOtpVerify(false);
      setErrMsg({cls:'alert alert-danger text-center', msg:"OTP length must be 6 digit."});
    } 
  }

const [intelValid,setIntelValid] = useState('');
const handleIntel = (dv)=>{
  setIntelValid(dv)
}



  if(!hasFilled){
    return (
            <Layout title="Log in:  Chaashni Couture" description="Chaashni Couture: Description">      
                <div className="site-content-wrap login">
                    <div className='loginbox'>
                        <h2>LOGIN / SIGN UP</h2>
                        <div className='login-inner'> 
                        {/* JSON.stringify(CurrCountry) */}
                        <div className='login-tab'>
                            <ul>                            
                                <li><NavLink className={({ isActive }) => isActive ? "active nav-link" : "nav-link"} to="/login">LOGIN</NavLink></li>
                                <li><NavLink className={({ isActive }) => isActive ? "active nav-link" : "nav-link"} to="/register">CREATE A NEW ACCOUNT</NavLink></li>
                            </ul>
                        </div>
                        <div className={`login-content ${loading?'loading-old':''}`}>
                            <div className='app__container'>
                                  <Form noValidate validated={validated} onSubmit={handleSend}>
                                  {errMsg.cls? <div className={errMsg.cls}>{errMsg.msg}</div>:'' }
                                    <div className='login-data'>For Existing Members</div>                                   
                                    <div className='login-data mobile-field'>
                                    <IntlTelInputBox setFullPhone={setFullPhone} selectedPhone={''} handleIntel={handleIntel} />
                                    </div>
                                    <div className='login-data'>
                                    {/*   <button type="submit" className="btn login-with-otp" style={{width:"200px"}} disabled={submitting?true:false}>{submitting?'Sending...':'Login with OTP'}</button> */}
                                    <button type="submit" className="btn login-with-otp" style={{width:"200px"}} disabled={!intelValid?true:false}>{submitting?'Sending...':'Login with OTP'}</button>
                                    </div>
                                    <div className='login-data'><Link to="/loginwithemail">Login with Email and Password Instead</Link></div>
                                    <div className='login-data'>Not a Member Yet? Click Here to <Link to="/register" style={{fontWeight:"bold", color:"#000", textDecoration:"none", display:"inline-block"}}>CREATE A NEW ACCOUNT</Link>
                                    </div>
                                  </Form>
                                  <div id="recaptcha"></div>
                            </div>
                        </div>
                        </div>
                    </div> 
                </div> 
            </Layout>
      
    ) 
  } else {
    return (
            <Layout title="Log in:  Chaashni Couture" description="Chaashni Couture: Description"> 
                <div className="site-content-wrap login">
                    <div className='loginbox'>
                        <h2>LOGIN / SIGN UP</h2>            
                        <div className='login-inner'> 
                            <div className='login-tab'>
                                <ul>                            
                                    <li><NavLink className={`nav-link ${({ isActive }) => isActive ? "active" : ""}`}>LOGIN</NavLink></li>
                                    <li><NavLink className={`nav-link ${({ isActive }) => isActive ? "active" : ""}`} to="/register">CREATE A NEW ACCOUNT</NavLink></li>
                                </ul>
                            </div>
                            <div className={`login-content ${loading?'loading-old':''}`}>
                                  <div className='app__container'>
                                      <Form noValidate validated={validated} onSubmit={(event)=>{ event.preventDefault(); verifyOtp() }}>
                                      {errMsg.cls? <div className={errMsg.cls}>{errMsg.msg}</div>:'' }
                                            <div className='login-data'>For Existing Members</div>
                                            <div className='login-data mobile-field'>
                                            <div className={`login-data mobile-field${otpStatus?' otp-send':''}`}>                                         
                                              <IntlTelInputBox setFullPhone={setFullPhone} selectedPhone={fullPhone} handleIntel={handleIntel}/>
                                            </div>
                                            <div className='otp-field new-otp-field'>
                                                <div className='otp-field-box'>
                                                <span className='otp-text login-data'>Please enter the OTP here.</span>
                                                  <OtpInput shouldAutoFocus={true} skipDefaultStyles={true} inputStyle={'otp-input'}  value={otp}  onChange={setOtp}  numInputs={6}  renderInput={(props) => <input {...props} />} />
                                                </div>
                                                <button type="submit" className="btn" disabled={otpVerify?true:false}>{otpVerify?'Verifying...':'Verify OTP'}</button>
                                                <div className='new-resend-otp'>
                                                <button type='button' onClick={() => resendOTP()} disabled={otpTime > 0}><span>{isButtonDisabled ? "Sending" : "Resend OTP"}</span></button>
                                                {otpTime > 0 && <div className='red-text'>({otpTime})</div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='login-data'><Link to="/loginwithemail">Login with Email and Password Instead</Link></div>
                                        <div className='login-data'>Not a Member Yet? Click Here to <Link to="/register" style={{fontWeight:"bold", color:"#000", textDecoration:"none"}}>CREATE A NEW ACCOUNT</Link>
                                        </div>
                                      </Form>
                                    <div id="recaptcha"></div>
                                  </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
    )
  }
}

export default App;